export const DEFAULT_TABLE_LAYOUT_TYPE = 'fitDataStretch';

export const DEFAULT_COLUMN_CALC_TYPE = 'table';

export const DEFAULT_BOTTOM_MARGIN = 24;

export const DEFAULT_THROTTLE_TIME = 300;

export const DEFAULT_DATA_TREE_CHILD_IDENT = 24;

export const DEFAULT_ROW_HEIGHT = 48;

export const DEFAULT_CHILDREN_FIELD_NAME = '_children';

export const DEFAULT_DATA_TREE_START_EXPANDED = [true, false];
